import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import cx from 'classnames';

type Props = {
  className?: string;
  id?: string;
  children?: ReactNode;
};

export const Badges = (props: Props) => {
  const { children, className, id } = props;

  return (
    <Wrapper id={id} className={cx('man-ui badges', className)}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  > * {
    margin-left: 15px;

    &:first-child {
      margin-left: 5px;
    }
  }
`;
